jQuery( ( $ ) => {
	$.fn.datepicker.DPGlobal.template = `${'<div class="datepicker">' +
		'<div class="datepicker-days">' +
		'<table class="table">'}${ 
		$.fn.datepicker.DPGlobal.headTemplate 
	}<tbody></tbody>${ 
		$.fn.datepicker.DPGlobal.footTemplate 
	}</table>` +
		'</div>' +
		'<div class="datepicker-months">' +
		`<table class="table">${ 
			$.fn.datepicker.DPGlobal.headTemplate 
		}${$.fn.datepicker.DPGlobal.contTemplate 
		}${$.fn.datepicker.DPGlobal.footTemplate 
		}</table>` +
		'</div>' +
		'<div class="datepicker-years">' +
		`<table class="table">${ 
			$.fn.datepicker.DPGlobal.headTemplate 
		}${$.fn.datepicker.DPGlobal.contTemplate 
		}${$.fn.datepicker.DPGlobal.footTemplate 
		}</table>` +
		'</div>' +
		'<div class="datepicker-decades">' +
		`<table class="table">${ 
			$.fn.datepicker.DPGlobal.headTemplate 
		}${$.fn.datepicker.DPGlobal.contTemplate 
		}${$.fn.datepicker.DPGlobal.footTemplate 
		}</table>` +
		'</div>' +
		'<div class="datepicker-centuries">' +
		`<table class="table">${ 
			$.fn.datepicker.DPGlobal.headTemplate 
		}${$.fn.datepicker.DPGlobal.contTemplate 
		}${$.fn.datepicker.DPGlobal.footTemplate 
		}</table>` +
		'</div>' +
		'</div>';

} );
